import React from 'react';

const Coffee = props => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    height={20}
    width={20}
    viewBox="0 0 26 26"
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill="transparent"
      stroke="#224251"
      d="M20.3 15.8V7.3h-15v8.5c0 4.1 3.4 7.5 7.5 7.5s7.5-3.4 7.5-7.5zM20.3 15.3h2.5c1.8 0 3-1.7 3-3.5s-1.2-3.5-3-3.5h-2.5M3.3 23.3h23"
    />
  </svg>
);

export default Coffee;
